import { IOrganizationDetailsDTO } from '../../../../../../api/organizations.dao';

export enum OrganizationLinkType {
    Presenter = 'presenter',
    Participant = 'participant'
}
export type DTOKey = IOrganizationDetailsDTO['participantLink' | 'presenterLink'];

export type SplitLink = [string, string];


export class OrganizationLinkMapper {
    static toVmInitParams(type: OrganizationLinkType, dto: IOrganizationDetailsDTO): SplitLink {
        return this.linkToParts(type, Reflect.get(dto, this.getDtoKeyByType(type)));
    }

    static linkToParts(type: OrganizationLinkType, link: string = ''): SplitLink {
        const customPartIndex = this.getLinkEditablePartIndexByPath(this.getPathKeyByType(type), link);
        return [
            String.prototype.slice.call(link || '', 0, customPartIndex),
            String.prototype.slice.call(link || '', customPartIndex)
        ];
    }

    static getLinkEditablePartIndexByPath(pathKey: string, link: string = ''): number {
        return String.prototype.indexOf.call(link || '', pathKey) + pathKey.length;
    }

    static getDtoKeyByType(type: OrganizationLinkType): DTOKey {
        return `${type}Link`;
    }
    static getPathKeyByType(type: OrganizationLinkType): string {
        return `/${type}/`;
    }
}
